import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
	path: '/',
	name: 'Home',
	redirect: '/index',
	component: () => import( /* webpackChunkName: "about" */ '../views/Home.vue'),
	children: [{
		path: "/index",
		name: "index",
		component: () => import("../views/index/index.vue")

	}, {
		path: "/pgzc",
		name: "品管政策",
		component: () => import("../views/other/pgzc.vue")

	}, {
		path: "/jyjfz",
		name: "圆晶级封装",
		component: () => import("../views/fwnr/jyjfz.vue")

	}, 
	// {
	// 	path: "/FOStrip",
	// 	name: "FOStrip",
	// 	component: () => import("../views/xjjs/FOStrip.vue")

	// },
	 {
		path: "/turnkey",
		name: "turnkey",
		component: () => import("../views/fwnr/turkey.vue")

		},
		// {
		// path: "/Co-Package",
		// name: "Co-Package Optics",
		// component: () => import("../views/xjjs/Co-Package.vue")

		// }
	// 	, {
	// 	path: "/FOAIP",
	// 	name: "FOAIP",
	// 	component: () => import("../views/xjjs/FOAIP.vue")

	// }, {
	// 	path: "/Hyper",
	// 	name: "Hyper",
	// 	component: () => import("../views/xjjs/Hyper.vue")

	// }, 
	// {
	// 	path: "/yfjh",
	// 	name: "研发计划",
	// 	component: () => import("../views/xjjs/yfjh.vue")

	// }, 
	{
		path: "/dps",
		name: "dps",
		component: () => import("../views/fwnr/dps.vue")

	}, {
		path: "/csfw",
		name: "测试服务",
		component: () => import("../views/fwnr/csfw.vue")

	}, {
		path: "/jrwm",
		name: "加入我们",
		component: () => import("../views/other/jrwm.vue")

	}, {
		path: "/yjysm",
		name: "愿景与使命",
		component: () => import("../views/other/yjysm.vue")

	}, {
		path: "/qyjyln",
		name: "企业经营理念",
		component: () => import("../views/other/qyjyln.vue")

	}, {
		path: "/ysqzc",
		name: "隐私权政策",
		component: () => import("../views/index/ysqzc.vue")

	}, {
		path: "/gszl",
		name: "经营团队",
		component: () => import("../views/about/gszl.vue")

	},
	//  {
	// 	path: "/details",
	// 	name: "新闻详情",
	// 	component: () => import("../views/about/details.vue")

	// },
	 {
		path: "/flsm",
		name: "法律声明",
		component: () => import("../views/about/flsm.vue")

	}, {
		path: "/llwm",
		name: "联络我们",
		component: () => import("../views/about/llwm.vue")

	}, {
		path: "/about",
		name: "公司简介",
		component: () => import("../views/about/about.vue")

	},
	//  {
	// 	path: "/news",
	// 	name: "新闻中心",
	// 	component: () => import("../views/about/news-new.vue")
	// }, {
	// 	path: "/news-list",
	// 	name: "新闻列表",
	// 	component: () => import("../views/about/news-list.vue")
	// },
	{
		path: "/category-list",
		name: "分类列表",
		component: () => import("../views/about/category-list.vue")
	},{
		path: "/video-list",
		name: "视频列表",
		component: () => import("../views/about/video-list.vue")
	}]
}
]

const router = new VueRouter({
	mode: 'history',
	//base: process.env.BASE_URL,
	base: process.env.VUE_APP_CONTEXT_RESOURCE + "/",
	routes,
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	}
})

export default router
